<ng-container *ngIf="component.data$ | async as data">
  <ng-container *ngIf="data.urlLink?.length; else noLink">
    <cx-generic-link
      [url]="data.urlLink"
      (click)="onBannerClick()"
      [target]="[true, 'true'].includes(data.external) ? '_blank' : null"
      [title]="data.media?.altText"
    >
      <sd-banner-content
        [simpleBannerData]="data"
        [sdInViewport]="0.5"
        [intersectedOnce]="true"
        (intersected)="onBannerIntersect()"
      ></sd-banner-content>
    </cx-generic-link>
  </ng-container>
  <ng-template #noLink>
    <sd-banner-content [simpleBannerData]="data" [useGallery]="true"></sd-banner-content>
  </ng-template>
</ng-container>
